var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-time"},[(_vm.time)?_c('span',[_vm._v(_vm._s(_vm.time))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }